import h from '../lib/h';

const menuIconHandler = () => {

  const menus = document.querySelectorAll('.navigation:not(.mobile-navigation)');

  function handleIcon(navigation) {
    const icon = navigation.getAttribute('data-icon');
    const iconStyles = navigation.getAttribute('data-icon-style');

    const submenus = navigation.querySelectorAll('.submenu > .submenu');

    if(!icon) {
      return;
    }

    submenus.forEach((sub) => {
      const template = h('span', { class: 'nav-icon nav-sub-icon material-icons ' + iconStyles });
      template.setAttribute('data-icon', icon);

      if(sub.parentElement.querySelector(':scope > .left-menu')) {
        sub.insertBefore(template, sub.firstChild);
      } else {
        sub.appendChild(template);
      }

      sub.classList.add('has-icon');
    });
  }

  function init() {
    menus.forEach((nav) => {
      if(!nav.getAttribute('data-icon')) {
        return;
      }

      handleIcon(nav);
    });
  }

  init();
}

export default menuIconHandler;
